import { CHECK_STATUS } from '../types';
import abortAfter from './abortAfter';

export const id = 'socketReachability';
export const label = 'WebSocket Server Reachability';

const PING_URL = 'https://web-socket.upshow.tv/ping';
const TIMEOUT_MS = 8000;

export async function run(_ctx) {
  const start = Date.now();
  try {
    const response = await fetch(PING_URL, { signal: abortAfter(TIMEOUT_MS) });
    const body = await response.text();
    const durationMs = Date.now() - start;

    if (!response.ok) {
      return {
        id,
        label,
        status: CHECK_STATUS.FAIL,
        detail: `WebSocket server returned HTTP ${response.status}`,
        detailData: { httpStatus: response.status, body: body.slice(0, 100) },
        durationMs,
      };
    }

    if (body.trim().toUpperCase() !== 'PONG') {
      return {
        id,
        label,
        status: CHECK_STATUS.FAIL,
        detail: 'WebSocket server returned unexpected response',
        detailData: { httpStatus: response.status, body: body.slice(0, 100) },
        durationMs,
      };
    }

    return {
      id,
      label,
      status: CHECK_STATUS.PASS,
      detail: 'WebSocket server reachable and responding',
      detailData: { httpStatus: response.status },
      durationMs,
    };
  } catch (err) {
    return {
      id,
      label,
      status: CHECK_STATUS.FAIL,
      detail: `WebSocket server unreachable: ${err?.message ?? err}`,
      detailData: { httpStatus: null },
      durationMs: Date.now() - start,
    };
  }
}
